var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dl',{staticClass:"flag",class:{ warning: _vm.record.warning, clickable: _vm.clickCallback }},[_c('dd',[_c('div',{staticClass:"label"},[_c('span',[_vm._v(_vm._s(_vm.record.areaName ?? '未知地区'))])]),_c('div',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.record.progress ?? '--')+"%")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }